import { render, staticRenderFns } from "./ProductParametersBundle.vue?vue&type=template&id=e75812ca&"
import script from "./ProductParametersBundle.vue?vue&type=script&lang=js&"
export * from "./ProductParametersBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports